export let maxCharacterMessage = (field, limit) =>
  field + " must be at most " + limit + " characters.";
export let minCaharacterMessage = (field, limit) =>
  field + " must be at least " + limit + " characters.";
